import { z } from "zod";
import { PartialUserFieldsSchema, UserSchema } from "./User";
import { CompanySchema } from "./Company";
import { ProductSchema } from "./Product";

export const DiscountCodeFieldsSchema = z.object({
  id: z.number(),
  code: z.string(),
  name: z.string(),
  type: z.number(),
  scope: z.number(),
  value: z.number(),
  startDate: z.string(),
  endDate: z.string(),
  usageLimit: z.number(),
  createDate: z.string(),
  autoAddProducts: z.boolean(),
  autoAddDiscountCode: z.boolean(),
  creator: UserSchema,
});
export const PartialDiscountCodeFieldsSchema =
  DiscountCodeFieldsSchema.deepPartial();

export const DiscountCodeExtraFieldsSchema = z.object({
  products: ProductSchema,
  categories: PartialUserFieldsSchema,
  excludedProducts: ProductSchema,
  companies: CompanySchema,
});

export const PartialDiscountCodeExtraFieldsSchema =
  DiscountCodeExtraFieldsSchema.deepPartial();

export const DiscountCodeSchema = z.intersection(
  DiscountCodeFieldsSchema,
  DiscountCodeExtraFieldsSchema
);

export type DiscountCodeFields = z.infer<typeof DiscountCodeFieldsSchema>;
export type PartialDiscountCodeFields = z.infer<
  typeof PartialDiscountCodeFieldsSchema
>;

export type DiscountCodeExtraFields = z.infer<
  typeof DiscountCodeExtraFieldsSchema
>;
export type PartialDiscountCodeExtraFields = z.infer<
  typeof PartialDiscountCodeExtraFieldsSchema
>;

export type DiscountCode = z.infer<typeof DiscountCodeFieldsSchema>;
